__turbopack_context__.v({
  "relatedArticle": "ArticleSectionRelatedLinkList-module-scss-module__EHg0EW__relatedArticle",
  "title": "ArticleSectionRelatedLinkList-module-scss-module__EHg0EW__title",
});
